import { useMemo, useSyncExternalStore } from 'react';
import { getState, subscribe } from '../store';
import { buildAlerts, countCheckingMonitors, isFailedCheck, latestAlertTime, needsAttention } from '../utils';

const useMonitorAlerts = () => {
    const state = useSyncExternalStore(subscribe, getState);

    return useMemo(() => {
        const alerts = buildAlerts(state.monitors, state.seen);
        const unread = alerts.filter(alert => alert.isUnread);
        const arrivalOrder = state.arrivals.map(entry => entry.monitorId);
        const byId = new Map(alerts.map(alert => [alert.monitorId, alert]));
        const now = Date.now();

        const arrivalAlerts = state.arrivals
            .filter(entry => !entry.dismissed && !(state.snoozedUntil[entry.monitorId] > now))
            .map(entry => byId.get(entry.monitorId))
            .filter(alert => alert?.isUnread);
        const missedAlerts = unread.filter(alert => !arrivalOrder.includes(alert.monitorId));
        const missedAttention = missedAlerts.filter(needsAttention);
        const cardAlerts = [
            ...arrivalAlerts,
            ...missedAlerts.filter(alert => !(state.snoozedUntil[alert.monitorId] > now)),
        ].filter(alert => !isFailedCheck(alert));

        return {
            loaded: state.monitors != null,
            stopped: state.stopped,
            alerts,
            unreadCount: unread.length,
            unreadAttentionCount: unread.filter(needsAttention).length,
            checkingCount: countCheckingMonitors(state.monitors),
            runningToastHidden: state.runningToastHidden,
            arrivalAlerts,
            cardAlerts,
            missedAttention,
            lastCheckAt: latestAlertTime(missedAttention),
            bannerDismissed: missedAttention.every(
                alert => state.bannerDismissedFor[alert.monitorId] === alert.identity
            ),
        };
    }, [state]);
};

export default useMonitorAlerts;
